import { render, staticRenderFns } from "./DriveAlbum.vue?vue&type=template&id=5f0a92d0&scoped=true&"
import script from "./DriveAlbum.vue?vue&type=script&lang=js&"
export * from "./DriveAlbum.vue?vue&type=script&lang=js&"
import style0 from "./DriveAlbum.vue?vue&type=style&index=0&id=5f0a92d0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f0a92d0",
  null
  
)

export default component.exports